import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import ViewNav from 'components/ViewNav';
import IndividualDevelopmentPlan from './component';
import { routes as individualDevelopmentPlanListView } from './IndividualDevelopmentPlanListView';
import { routes as individualDevelopmentPlanDetailView } from './IndividualDevelopmentPlanDetailView';
import { routes as individualDevelopmentPlanApprovalView } from './IndividualDevelopmentPlanApprovalView';
import { accessors as idpAccessors } from 'data/IndividualDevelopmentPlans';
import { actions as groupActions } from 'containers/Group';

const secondLevelTabs = (getState, { groupId, groupIdpId }, push, buildRoute) => {
  let groupIdpList = idpAccessors.getGroupIdpList(getState(), groupId);
  if (groupIdpList.size <= 1) return [];
  groupIdpList = groupIdpList.toList();
  return groupIdpList.map((groupIdpInfo) => ({
    text: groupIdpInfo.name.toUpperCase(),
    onClick: () => push(buildRoute(`/group/${groupId}/progress-report-hfv4/${groupIdpInfo.id}`)),
    isActive: groupIdpId === groupIdpInfo.id.toString(),
  })).toArray();
};

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'view-nav': {
        component: ViewNav,
        order: 2,
        props: {
          hideExpandable: true,
        },
      },
    },
  },
  path: 'progress-report-hfv4',
  component: IndividualDevelopmentPlan,
  secondLevelTabs: ({ push, params, buildRoute }) =>
    secondLevelTabs(getState, params, push, buildRoute),
  breadcrumbLabels: ({ params, buildRoute }) => ({
    label: idpAccessors.getReportName(getState(), params.groupIdpId, 'progress report'),
    href: buildRoute(buildRoute(`/group/${params.groupId}/progress-report-hfv4/${params.groupIdpId}`)),
  }),
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.IndividualDevelopmentPlan.View) &&
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.ProgressReportHFv4),
  childRoutes: [
    individualDevelopmentPlanApprovalView,
    individualDevelopmentPlanListView,
    individualDevelopmentPlanDetailView,
  ],
  tab: {
    label: (params) => (groupActions.isDisabledReportActions(getState(), params.groupId) ?
      'Historical Progress Reports' :
      'Progress Reports'),
    order: 10,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.IndividualDevelopmentPlan.View) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.ProgressReportHFv4),
  },
});



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/routes.js